import Cargar_facturas from "../../../../components/ingreso_facturas/ingreso_facturas.vue";

export default {
  components: {
    Cargar_facturas
  },

  data() {
    return {
      usuario: '',
      loading_suscripciones: false,
      suscripciones: [],
      columnas_suscripciones: [
        { text: "Suscripción", value: 'tipo_suscripcion.nombre' },
        { text: "Descripción", value: 'tipo_suscripcion.descripcion' },
        { text: "Fecha Inicio", value: 'fecha_inicio' },
        { text: "Fecha Fin", value: 'fecha_fin' },
        { text: "Ver declaraciones", value: 'accion' },
      ],
      dialogeDeclaraciones: false,
      declaraciones: [],
      columnas_declaraciones: [
        { text: 'Mes', value: 'mes' },
        { text: 'Fecha en que se presentó', value: 'fecha_declaracion' },
        { text: 'Sumatoria de facturas Q', value: 'total_fatura', align: 'end' },
        { text: 'Sumatoria de retenciones Q', value: 'total_retencion', align: 'end' },
        { text: 'Impuesto Pagado Q', value: 'pago', align: 'end' },
        { text: 'Estado de la declaración', value: 'status' },
        { text: 'Cargar documentos', value: 'accion' }
      ],
      anios: [],
      anio_seleccionado: 0,
      loading_anio: false,
      nombre_usuario: '',
      cargarFacturasRetenciones: false,
      data: "",
      data_cortesia_ros: {},
      dialogPresentara0: false,
      item_aux: '',
      loading: false,
      numero_formulario: null,
      documento: null,
      documento_aux: null,
      meses: {
        "Enero": 1,
        "Febrero": 2,
        "Marzo": 3,
        "Abril": 4,
        "Mayo": 5,
        "Junio": 6,
        "Julio": 7,
        "Agosto": 8,
        "Septiembre": 9,
        "Octubre": 10,
        "Noviembre": 11,
        "Diciembre": 12
      },
      mes_seleccionado: 0,
      anio_busqueda: 0,
      usuario_id: 0,
      info_usuario: {},
      dialogEnviarFactura: false,
      loading_envio_factura: false,
      dialogCargaCortesiaROS: false,
      data_cortesia_ros: {
        "info_general": {
          "usuario_presento_id": 0,
          "usuario_id": 0,
          "fecha_presentacion": "",
          "fecha_aux": "",
        },
        "carga_pc": {
          "total_facturas": 0,
          "impuesto_determinado": 0,
          "rent_periodo_declarar": 0,
          "impuesto_pagar": 0,
          "remanente_retencion": 0,
          "numero_formulario": 0
        },
        "carga_ros": {
          "debito_fiscal": {
            "servicios_grav_base_b_a_1_1": 0,
            "servicios_grav_debitos_a_1_2": 0,
            "sum_base_a_2_1": 0,
            "sum_debitos_a_2_2": 0
          },
          "credito_fiscal": {
            "veh_terr_usado_base_b_1_1": 0,
            "veh_terr_usado_creditos_b_1_2": 0,
            "veh_terr_nuevo_base_b_2_1": 0,
            "veh_terr_nuevo_creditos_b_2_2": 0,
            "combustible_base_b_3_1": 0,
            "combustible_creditos_b_3_2": 0,
            "otras_comp_bienes_base_b_4_1": 0,
            "otras_comp_creditos_bienes_b_4_2": 0,
            "serv_adquiridos_base_b_5_1": 0,
            "serv_adquiridos_creditos_b_5_2": 0,
            "impor_ca_base_b_6_1": 0,
            "impor_ca_creditos_b_6_2": 0,
            "fyduca_base_b_7_1": 0,
            "fyduca_creditos_b_7_2": 0,
            "resto_mundo_base_b_8_1": 0,
            "resto_mundo_creditos_b_8_2": 0,
            "comp_acti_fijos_base_b_9_1": 0,
            "comp_acti_fijos_creditos_b_9_2": 0,
            "impor_acti_fijos_base_b_10_1": 0,
            "impor_acti_fijos_creditos_b_10_2": 0,
            "civa_base_b_11_1": 0,
            "civa_creditos_b_11_2": 0,
            "remanente_credito_iva_base_b_12_1": 0,
            "remanente_credito_iva_creditos_b_12_1": 0,
            "sum_base_b_13_1": 0,
            "sum_creditos_b_13_2": 0
          },
        },
        "determinacion_impuesto": {
          "opr_locales_c_1": 0,
          "expo_transfe_c_2": 0,
          "impuesto_determinado_c_3": 0,
          "impuesto_determinado_c_4": 0,
          "credito_expo_transfe_c_5": 0,
          "saldo_impuesto_c_6": 0,
          "remanente_credito_iva_c_7": 0,
        }
      },
      headers: [
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui",
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "Contraseña agencia Virtual",
          align: "center",
          sortable: false,
          value: "password_sat",
        },
        {
          text: "Dia de declaración",
          align: "center",
          sortable: true,
          value: "fecha_declaracion",
        },
        {
          text: "Estado Facturas",
          align: "center",
          sortable: true,
          value: "facturas",
        },
        {
          text: "Estado Retenciones",
          align: "center",
          sortable: true,
          value: "retenciones",
        },
        {
          text: "# de Registro de Colaborador TIC",
          align: "center",
          sortable: true,
          value: "asignado_id",
        },
        {
          text: "Colaborador TIC asignado",
          align: "center",
          sortable: true,
          value: "asignado",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      data_fecha: {
        fecha: "2024/02/10",
        fecha_usuario: "10/02/2024",
      },
      letfechasuscripcion: '',
      tipo_id: 1,
      letitem: '',
      letnit: null,
      letusuarios: [],
      isISR: false,
      anio_busqueda_docs: null,
    };
  },
  async created() {
    console.log("estado_declaracion_admin.0");
    let usuario = this.$route.params.usuario;
    this.usuario_id = usuario;
    this.info_usuario.completo = this.$route.params.completo;
    this.info_usuario.cui = this.$route.params.cui;
    this.info_usuario.nit = this.$route.params.nit;
    this.letnit = this.$route.params.nit;
    this.info_usuario.password = this.$route.params.password;
    this.nombre_usuario = this.$route.params.nombre;
    this.info_usuario.tipo_regimen = this.$route.params.tipo_regimen;
    this.tipo_id = this.$route.params.tipo_regimen;
    if(this.tipo_id == 2){
      this.isISR = true;
    }

    await this.obtenerSuscripcionesUsuario(usuario);
    // this.anios.push(2022);
    let anio = new Date(Date.now()).getFullYear() - 3;
    this.anios.push(anio);
    for (let i = 0; i < 6; i++) {
      this.anios.push(anio + (i + 1));
    }
  },
  watch: {
    numero_formulario() {
      console.log('numero_formulario');
      this.numero_formulario = this.numero_formulario.trim();
    },
    async documento(value) {
      console.log('documento');
      if (value === null || this.documento === null) {
        this.documento_aux = null;
        return;
      }
      try {
        let fr = new FileReader()
        fr.addEventListener("load", async (e) => {
          this.documento_aux = e.target.result;
          this.loading = false;
        });
        fr.readAsDataURL(value)
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    }
  },
  computed: {
    size() {
      console.log('size');
      const size = { xs: "x-small", sm: "small", md: "small", lg: "small" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
  },
  methods: {
    async confirmarCargaCortesiaROS() {
      console.log('confirmarCargaCortesiaROS');
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          let r = await this.$store.state.services.administradorService.cargaMasivaCortesia(this.data_cortesia_ros);
          if (r.data.success) {
            this.anio_seleccionado = this.anio_busqueda;
            await this.obtenerDetallePresentacionesAño();
            this.$toast.success("Presentación procesada exitosamente", { timeout: 4000 })
            this.loading = false;
            this.presentaciones = [];
            this.data = "";
            this.dialogCargaCortesiaROS = false;
            this.item_aux = '';
            this.documento = null;
            this.numero_formulario = null;
            this.documento_aux = null;
          } else {
            this.$toast.error("No es posible cargar la presentación")
            this.loading = false
            this.dialogCargaCortesiaROS = false;
            this.documento = null;
            this.documento_aux = null;
            this.numero_formulario = null;
          }
        } catch (error) {
          console.log(error);
          this.$toast.error("No es posible cargar la presentación de cortesia ROS")
          this.loading = false;
          this.dialogCargaCortesiaROS = false;
        }
      }
    },
    async confirmarEnviarFactura() {
      console.log('confirmarEnviarFactura');
      this.loading_envio_factura = true;
      try {
        let body = {
          documento: this.documento_aux,
          suscripcion_id: this.item_aux.id,
        }
        let r = await this.$store.state.services.administradorService.enviar_factura(body);
        this.documento_aux = null;
        this.dialogEnviarFactura = false;
        this.loading_envio_factura = false;
        this.item_aux = '';
        this.$toast.success("Factura enviada exitosamente");
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible enviar la factura")
        this.documento_aux = null;
        this.dialogEnviarFactura = false;
        this.loading_envio_factura = false;
        this.item_aux = '';
      }
    },
    enviarFactura(item) {
      console.log('enviarFactura');
      this.dialogEnviarFactura = true;
      this.item_aux = item;
    },
    convertirnumero(numero) {
      console.log('convertirnumero');
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))
    },
    async obtenerSuscripcionesUsuario(id) {
      console.log('obtenerSuscripcionesUsuario');
      try {
        this.suscripciones = [];
        this.loading_suscripciones = true;
        let r = await this.$store.state.services.usuarioService.obtenerSuscripcionesUsuario(id);
        let fecha_suscripcion = r.data.data[0].fecha_inicio;

        let fecha_suscripcion_array = fecha_suscripcion.split('-');
        this.letfechasuscripcion = fecha_suscripcion_array[2] + '-' + fecha_suscripcion_array[1] + '-' + fecha_suscripcion_array[0];
        let fecha_suscripcion_formateada = fecha_suscripcion_array[0] + '/' + fecha_suscripcion_array[1] + '/' + fecha_suscripcion_array[2];

        this.data_fecha.fecha = fecha_suscripcion ;
        this.data_fecha.fecha_usuario = fecha_suscripcion_formateada;

        r.data.data.filter(x => x.loading = false);
        this.suscripciones = r.data.data;
        this.loading_suscripciones = false;
      } catch (error) {
        this.loading_suscripciones = false;
        console.log(error, 'error al obtener el tipo de suscripciones');
      }
    },
    async obtenerDetallePresentaciones(item) {
      console.log('obtenerDetallePresentaciones');
      try {
        item.loading = true;
        let r = await this.$store.state.services.usuarioService.obtenerDetallePresentaciones(item.id);
        this.dialogeDeclaraciones = true;
        this.declaraciones = r.data.data;
        item.loading = false;
      } catch (error) {
        item.loading = false;
        console.log(error, 'error al ver el detalle de las declaraciones');
      }
    },
    allowedDates: (date) =>
      date <=
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    async obtenerDetallePresentacionesAño() {
      console.log('obtenerDetallePresentacionesAño');
      let usuario = this.$route.params.usuario;
      this.declaraciones = [];
      this.anio_busqueda = this.anio_seleccionado;
      try {
        this.data_fecha.regimen_id = this.tipo_id;
      } catch (error) {
        console.log(error);
      }
      console.log('this.data_fecha:', this.data_fecha);
      this.anio_busqueda_docs = this.data_fecha.fecha.split('-');
      // try {
      //   let r = await this.$store.state.services.presentacionService.getListaodDeclaracionesIngreso(this.data_fecha);
      //   console.log('getListaodDeclaracionesIngreso:',r);
      //   this.letusuarios = r.data.data;
      //   let foundUser = r.data.data.find(user => user.nit === this.letnit);
      //   if (foundUser) {
      //     this.letitem = foundUser;
      //   } else {
      //     console.log('User with nit', this.letnit, 'not found.');
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
      try {
        this.loading_anio = true;
        let r = await this.$store.state.services.usuarioService.obtenerDetallePresentacionCompleta_Ros(usuario, this.anio_seleccionado);
        r.data.data.filter(x => x.loading = false)
        this.dialogeDeclaraciones = true;
        this.declaraciones = r.data.data;
        this.loading_anio = false;
        this.anio_seleccionado = '';
      } catch (error) {
        this.loading_anio = false;
        console.log(error, 'error al ver el detalle de las declaraciones');
      }
    },
    async regresar() {
      console.log('regresar');
      this.cargarFacturasRetenciones = false;
      this.data = "";
      this.anio_seleccionado = this.anio_busqueda;
      await this.obtenerDetallePresentacionesAño();
      this.dialogeDeclaraciones = true;
    },
    async cargarDocumentos(item) {
      console.log('cargarDocumentos:', item);

      let mes = '0';
      if(item.mes == 'Enero'){
        mes = '02';
      }else if(item.mes == 'Febrero'){
        mes = '03';
      }else if(item.mes == 'Marzo'){
        mes = '04';
      }else if(item.mes == 'Abril'){
        mes = '05';
      }else if(item.mes == 'Mayo'){
        mes = '06';
      }else if(item.mes == 'Junio'){
        mes = '07';
      }else if(item.mes == 'Julio'){
        mes = '08';
      }else if(item.mes == 'Agosto'){
        mes = '09';
      }else if(item.mes == 'Septiembre'){
        mes = '10';
      }else if(item.mes == 'Octubre'){
        mes = '11';
      }else if(item.mes == 'Noviembre'){
        mes = '12';
      }else if(item.mes == 'Diciembre'){
        // mes = '01';
        mes = '13';
      }
      console.log('mes:', mes);
      mes = this.anio_busqueda_docs[0]+'-'+mes+'-'+this.anio_busqueda_docs[2];
      console.log('mesformat:', mes);
      this.anio_busqueda_docs = mes.replace(/\//g, '-');
      console.log('anio_busqueda_docs:', this.anio_busqueda_docs);

      this.data_fecha.fecha = mes;
      this.data_fecha.fecha_usuario = this.anio_busqueda_docs;
      console.log('this.data_fecha a enviar:', this.data_fecha);
      try {
        let r = await this.$store.state.services.presentacionService.getListaodDeclaracionesIngreso(this.data_fecha);
        console.log('getListaodDeclaracionesIngreso:',r);
        this.letusuarios = r.data.data;
        let foundUser = r.data.data.find(user => user.nit === this.letnit);
        if (foundUser) {
          this.letitem = foundUser;
        } else {
          console.log('User with nit', this.letnit, 'not found.');
        }
      } catch (error) {
        console.log(error);
      }

      try {
        item = this.letitem;

        // item.fecha = this.anio_busqueda_docs;
        this.data = item;
        this.data.carga = false;
        this.dialogeDeclaraciones = false;

        this.cargarFacturasRetenciones = true;
        this.data.fecha = this.data_fecha.fecha_usuario;
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible el ingreso de facturas");
      }
    },
    presentar0(item) {
      console.log('presentar0');
      this.dialogPresentara0 = true;
      this.item_aux = item;
      this.mes_seleccionado = this.meses[this.item_aux.mes];
    },
    async confirmar_enviarSinFacturasYRetenciones() {
      console.log('confirmar_enviarSinFacturasYRetenciones');
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          let mes = -1;
          let anio = -1;
          if (this.mes_seleccionado == 12) {
            mes = 1;
            anio = this.anio_busqueda + 1;
          } else {
            mes = this.mes_seleccionado + 1;
            anio = this.anio_busqueda;
          }
          console.log("mes", mes, "anio", anio);
          let r = await this.$store.state.services.presentacionService.forzarEnvioA0({ aplica_sub: false, id: this.usuario_id, fecha: anio + '-' + mes + '-01', numero_formulario: this.numero_formulario, documento: this.documento_aux });
          console.log("enviar sin retenciones");
          if (r.data.success) {
            this.anio_seleccionado = this.anio_busqueda;
            await this.obtenerDetallePresentacionesAño();
            this.$toast.success("Presentación procesada exitosamente", { timeout: 4000 })
            this.loading = false;
            this.presentaciones = [];
            this.data = "";
            this.dialogPresentara0 = false;
            this.item_aux = '';
            this.documento = null;
            this.numero_formulario = null;
            this.documento_aux = null;
          } else {
            this.$toast.error("No es posible trasladar a pago")
            this.loading = false
            this.dialogPresentara0 = false;
            this.documento = null;
            this.documento_aux = null;
            this.numero_formulario = null;
          }
        } catch (error) {
          console.log(error);
          this.$toast.error("No es posible trasladar a pago")
          this.loading = false;
          this.dialogPresentara0 = false;
        }
      }
    },
  },
  async mounted() {
    console.log("/estado_declaracion_admin/");
  },
}